export default __webpack_public_path__ + "static/media/Background_00233.d6db6e06.png";